import { render, staticRenderFns } from "./tabFixtureLineups.vue?vue&type=template&id=5da6e07a&"
import script from "./tabFixtureLineups.vue?vue&type=script&lang=js&"
export * from "./tabFixtureLineups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports